import { useRef, useState } from 'react';
import { A11y } from 'swiper/modules';
import 'swiper/css';
import type { Swiper as SwiperRef } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import styles from './CaseSlider.module.scss';
import { UI_CaseSliderItem, UI_CaseSliderItemProps } from './CaseSliderItem/CaseSliderItem';

export interface UI_CaseSliderProps {
	className?: string;
	slides?: UI_CaseSliderItemProps[];
}

export const UI_CaseSlider = ({ className, slides }: UI_CaseSliderProps) => {
	const swiperInstanceRef = useRef<SwiperRef | null>(null);
	const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);
	const [isBeginning, setIsBeginning] = useState<boolean>(true);
	const [isEnd, setIsEnd] = useState<boolean>((slides?.length ?? 0) <= 1);
	const updateEdgeState = (swiper: SwiperRef) => {
		setIsBeginning(swiper.isBeginning);
		setIsEnd(swiper.isEnd);
	};
	const handleSlideChange = (swiper: SwiperRef) => {
		setActiveSlideIndex(swiper.realIndex);
		updateEdgeState(swiper);
	};
	if (!slides?.length) return null;
	const hasMultipleSlides = slides.length > 1;
	const handlePrevClick = () => swiperInstanceRef.current?.slidePrev();
	const handleNextClick = () => swiperInstanceRef.current?.slideNext();

	return (
		<div className={classNames(styles.CaseSlider, className)}>
			<Swiper
				modules={[A11y]}
				slidesPerView={1}
				spaceBetween={0}
				autoHeight
				onSlideChange={handleSlideChange}
				onSwiper={(swiper) => {
					swiperInstanceRef.current = swiper;
					updateEdgeState(swiper);
				}}
				className={classNames(styles.CaseSlider, styles[`u-color___${slides[activeSlideIndex]?.bgColor}`])}
			>
				{slides.map((slide, index, arr) => (
					<SwiperSlide key={index}>
						<UI_CaseSliderItem
							{...slide}
							slideNumber={arr.length}
							onHandlePrevClick={hasMultipleSlides ? handlePrevClick : undefined}
							onHandleNextClick={hasMultipleSlides ? handleNextClick : undefined}
							disablePrevButton={isBeginning}
							disableNextButton={isEnd}
						/>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};
